/**
 * @namespace Requester.v2.emotion
 * @intdocs
 */

export * from './ImpactEmotion';